module.exports = __webpack_public_path__ + "static/media/Buzzer_Helloween_Michael.66fa6643.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sound/Buzzer_Helloween_Michael.mp3
// module id = 286
// module chunks = 0